import React from 'react';
import Table from '../../../Components/Ui/Table';
import PropTypes from 'prop-types';
import toastService from '../../../services/toastService';

const BrandTable = ({
  products: items = [],
  selectedItems = [],
  setSelectedItems,
  isLoading = false,
}) => {
  const toggleSelect = (id) => {
    setSelectedItems((prev) => (prev.includes(id) ? [] : [id]));
  };

  const columns = [
    {
      header: '',
      accessor: (row) => (
        <input
          type="radio"
          name="productSelect"
          checked={selectedItems.includes(row._id)}
          onChange={() => toggleSelect(row._id)}
          disabled={isLoading || row.isTaken}
          aria-label={`Select product ${row.title}`}
        />
      ),
      className: 'text-center w-[40px] min-w-[40px]', // fixed size for radio
    },
    {
      header: 'Brand',
      accessor: (row) => (
        <span className="truncate block cursor-pointer" title={row.brand?.name}>
          {row.brand?.name || 'N/A'}
        </span>
      ),
      className: 'w-[15%] min-w-[120px]',
    },
    {
      header: 'Product',
      accessor: (row) => (
        <span
          className="block max-w-[100px] truncate whitespace-nowrap overflow-hidden cursor-pointer"
          title={row.title}
        >
          {row.title || 'N/A'}
        </span>
      ),
      className: 'w-[15%] min-w-[150px]',
    },

    {
      header: 'Category',
      accessor: (row) => (
        <span className="truncate block" title={row.category?.name}>
          {row.category?.name || 'N/A'}
        </span>
      ),
      className: 'w-[20%] min-w-[120px]',
    },
    {
      header: 'Product Code',
      accessor: (row) => (
        <span className="truncate block" title={row.productCode}>
          {row.productCode || 'N/A'}
        </span>
      ),
      className: 'w-[15%] min-w-[120px]',
    },
    {
      header: 'MRP',
      accessor: (row) => (
        <span className="text-green-500">
          {`₹${(row.mrp && typeof row.mrp === 'object' ? row.mrp.standard : row.mrp || 0).toFixed(2)}`}
        </span>
      ),
      className: 'text-center w-[20%] min-w-[100px]',
    },
  ];

  const getRowProps = (row) => {
    if (row.isTaken) {
      return {
        className: 'bg-gray-100 cursor-not-allowed',
        title: 'This product has already been added by another seller.',
      };
    }
    return {};
  };

  const handleRowClick = (row) => {
    if (row.isTaken) {
      toastService.info('This product is not available to sell right now.');
    }
  };

  return (
    <Table
      columns={columns}
      data={items}
      keyExtractor={(row) => row._id}
      isLoading={isLoading}
      emptyStateMessage="No products found"
      getRowProps={getRowProps}
      onRowClick={handleRowClick}
    />
  );
};

BrandTable.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string,
      brand: PropTypes.shape({
        name: PropTypes.string,
      }),
      category: PropTypes.shape({
        name: PropTypes.string,
      }),
      basePrice: PropTypes.number,
      sku: PropTypes.string,
      productCode: PropTypes.string,
      isTaken: PropTypes.bool,
    }),
  ),
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  setSelectedItems: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default BrandTable;
